export const BUSINESS_API_PREFIX = '/business/api';
export const BUSINESS_ACCOUNTS_AJAX_PREFIX = '/business_accounts/ajax';
